// USER_CLICKED actions
export const USER_CLICKED_UNSUBSCRIBE = 'acct/user/clicked_unsubscribe';
export const USER_CLICKED_UNSUBSCRIBE_REFUND_OPTION = 'acct/user/clicked_unsubscribe_refund_option';
export const USER_CLICKED_RESUBSCRIBE = 'acct/user/clicked_resubscribe';
export const USER_CLICKED_PAUSE = 'acct/user/clicked_pause';
export const USER_CLICKED_RESUME = 'acct/user/clicked_resume';
export const USER_CLICKED_UPGRADING_PLAN = 'acct/user/clicked_upgrading_plan';
export const USER_CLICKED_UPGRADE = 'acct/user/clicked_upgrade';
export const USER_CLICKED_FULL_REFUND = 'acct/user/clicked_full_refund';
export const USER_CLICKED_INVOICE_DOWNLOAD = 'acct/user/clicked_invoice_download';

// SYSTEM_action_process actions
export const SYSTEM_SUBSCRIPTION_UNSUBSCRIBE = 'acct/system/unsubscribe';
export const SYSTEM_SUBSCRIPTION_RESUBSCRIBE = 'acct/system/resubscribe';
export const SYSTEM_SUBSCRIPTION_PAUSE = 'acct/system/pause_subscription';
export const SYSTEM_SUBSCRIPTION_RESUME = 'acct/system/resume_subscription';
export const SYSTEM_SUBSCRIPTION_UPGRADE = 'acct/system/upgrade_subscription';
export const SYSTEM_SUBSCRIPTION_UPDATED_BILLING_DETAILS = 'acct/system/updated_billing_details';
export const SYSTEM_SUBSCRIPTION_UPDATED_PAYMENT_METHOD = 'acct/system/updated_payment_method';
